<div class="cookie-consent-container d-flex align-items-center text-center scroll-sm" *ngIf="!cookieAccepted">
    <!-- Main consent view -->
    <div class="cookie-consent-wrapper flex-column" *ngIf="!showCustomize">
        <img src="../../../../assets/img/cookie.svg" alt="cookie image">

        <div class="message my-3">
            <div class="english-text" *ngIf="currentLanguage === 'EN'">
                <h4>Cookie Settings</h4>
                <p>We use cookies to improve your experience on our website. Some cookies are essential for the site to function, while others help us analyze usage and provide personalized content.</p>
                <p><strong>Required Cookies:</strong> Necessary for age verification (18+) and basic site functionality.</p>
                <p><strong>Analytical Cookies:</strong> Help us understand how visitors use our website (Google Analytics, Microsoft Clarity).</p>
                <p><strong>Marketing Cookies:</strong> Used to show you relevant advertisements (Google AdSense).</p>
                <p>You can customize your preferences or accept/reject all optional cookies. You can change your settings anytime in "My Profile".</p>
            </div>
            <div class="german-text" *ngIf="currentLanguage === 'DE'">
                <h4>Cookie-Einstellungen</h4>
                <p>Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Einige Cookies sind für die Funktion der Website unerlässlich, während andere uns helfen, die Nutzung zu analysieren und personalisierte Inhalte bereitzustellen.</p>
                <p><strong>Erforderliche Cookies:</strong> Notwendig für die Altersverifikation (18+) und grundlegende Website-Funktionen.</p>
                <p><strong>Analytische Cookies:</strong> Helfen uns zu verstehen, wie Besucher unsere Website nutzen (Google Analytics, Microsoft Clarity).</p>
                <p><strong>Marketing-Cookies:</strong> Werden verwendet, um Ihnen relevante Werbung anzuzeigen (Google AdSense).</p>
                <p>Sie können Ihre Einstellungen anpassen oder alle optionalen Cookies akzeptieren/ablehnen. Sie können Ihre Einstellungen jederzeit unter "Mein Profil" ändern.</p>
            </div>
        </div>

        <!-- Buttons -->
        <div class="buttons">
            <button class="btn tr-btn-primary btn-accept" (click)="acceptAllCookies()">
                {{ currentLanguage === 'EN' ? 'Accept All' : 'Alle akzeptieren' }}
            </button>
            <button class="btn tr-btn-secondary btn-reject" (click)="rejectAllCookies()">
                {{ currentLanguage === 'EN' ? 'Reject All' : 'Alle ablehnen' }}
            </button>
            <button class="btn tr-btn-secondary btn-customize" (click)="showCustomizeOptions()">
                {{ currentLanguage === 'EN' ? 'Customize' : 'Anpassen' }}
            </button>
        </div>

        <!-- Privacy Policy Link -->
        <div class="privacy-link">
            <a routerLink="/privacy-policy" target="_blank">
                {{ currentLanguage === 'EN' ? 'Read our Privacy Policy' : 'Lesen Sie unsere Datenschutzerklärung' }}
            </a>
        </div>
    </div>

    <!-- Customize view with sidebar -->
    <div class="cookie-customize-wrapper" *ngIf="showCustomize">
        <!-- Sidebar Navigation -->
        <div class="cookie-sidebar">
            <div class="sidebar-logo">
                <img src="../../../../assets/img/cookie.svg" alt="cookie image">
            </div>
            <nav class="sidebar-nav">
                <button
                    class="sidebar-nav-item"
                    [class.active]="activeTab === 'overview'"
                    (click)="activeTab = 'overview'">
                    {{ currentLanguage === 'EN' ? 'DATA PROTECTION OVERVIEW' : 'DATENSCHUTZ-ÜBERSICHT' }}
                </button>
                <button
                    class="sidebar-nav-item"
                    [class.active]="activeTab === 'required'"
                    (click)="activeTab = 'required'">
                    {{ currentLanguage === 'EN' ? 'STRICTLY NECESSARY COOKIES' : 'UNBEDINGT ERFORDERLICHE COOKIES' }}
                </button>
                <button
                    class="sidebar-nav-item"
                    [class.active]="activeTab === 'analytics'"
                    (click)="activeTab = 'analytics'">
                    {{ currentLanguage === 'EN' ? 'ANALYTICS' : 'ANALYTIK' }}
                </button>
                <button
                    class="sidebar-nav-item"
                    [class.active]="activeTab === 'marketing'"
                    (click)="activeTab = 'marketing'">
                    {{ currentLanguage === 'EN' ? 'ADVERTISING/MARKETING' : 'WERBUNG/MARKETING' }}
                </button>
            </nav>
        </div>

        <!-- Content Area -->
        <div class="cookie-content">
            <!-- Overview Tab -->
            <div class="tab-content" *ngIf="activeTab === 'overview'">
                <h3>{{ currentLanguage === 'EN' ? 'Data Protection Overview' : 'Datenschutz-Übersicht' }}</h3>
                <div class="content-text" *ngIf="currentLanguage === 'EN'">
                    <p>This website uses cookies to improve your experience while you navigate through the website. The cookies that are categorized as necessary are stored on your browser as they are essential for the basic functionalities of the website.</p>
                    <p>We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent.</p>
                    <p>You have the option to opt-out of these cookies. But opting out of some of these cookies may affect your browsing experience.</p>
                </div>
                <div class="content-text" *ngIf="currentLanguage === 'DE'">
                    <p>Diese Website verwendet Cookies, um Ihre Erfahrung zu verbessern, während Sie durch die Website navigieren. Die als notwendig eingestuften Cookies werden in Ihrem Browser gespeichert, da sie für die grundlegenden Funktionen der Website unerlässlich sind.</p>
                    <p>Wir verwenden auch Cookies von Drittanbietern, die uns helfen zu analysieren und zu verstehen, wie Sie diese Website nutzen. Diese Cookies werden nur mit Ihrer Zustimmung in Ihrem Browser gespeichert.</p>
                    <p>Sie haben die Möglichkeit, diese Cookies abzulehnen. Das Ablehnen einiger dieser Cookies kann jedoch Ihre Browser-Erfahrung beeinträchtigen.</p>
                </div>
            </div>

            <!-- Required Cookies Tab -->
            <div class="tab-content" *ngIf="activeTab === 'required'">
                <h3>{{ currentLanguage === 'EN' ? 'Strictly Necessary Cookies' : 'Unbedingt erforderliche Cookies' }}</h3>
                <div class="cookie-toggle-row">
                    <span class="toggle-label">{{ currentLanguage === 'EN' ? 'Always Active' : 'Immer aktiv' }}</span>
                    <label class="toggle-switch disabled">
                        <input type="checkbox" [checked]="true" disabled>
                        <span class="toggle-slider"></span>
                    </label>
                </div>
                <div class="content-text" *ngIf="currentLanguage === 'EN'">
                    <p><strong>The provider/processor</strong><br>is TresorVino.</p>
                    <p><strong>Purpose(s)</strong><br>Age verification (18+), user authentication, shopping cart functionality, and basic site operation.</p>
                    <p><strong>Technologies such</strong><br>as cookies (especially first-party cookies like session cookies) and possibly comparable identifiers for session/user recognition.</p>
                    <p><strong>Storage duration</strong></p>
                    <ul class="cookie-duration-list">
                        <li><span class="cookie-name">tresInfo</span> : 365 days</li>
                    </ul>
                </div>
                <div class="content-text" *ngIf="currentLanguage === 'DE'">
                    <p><strong>Der Anbieter/Verarbeiter</strong><br>ist TresorVino.</p>
                    <p><strong>Zweck(e)</strong><br>Altersverifikation (18+), Benutzerauthentifizierung, Warenkorbfunktionalität und grundlegender Website-Betrieb.</p>
                    <p><strong>Technologien wie</strong><br>Cookies (insbesondere First-Party-Cookies wie Sitzungscookies) und möglicherweise vergleichbare Identifikatoren für die Sitzungs-/Benutzererkennung.</p>
                    <p><strong>Speicherdauer</strong></p>
                    <ul class="cookie-duration-list">
                        <li><span class="cookie-name">tresInfo</span> : 365 Tage</li>
                    </ul>
                </div>
            </div>

            <!-- Analytics Tab -->
            <div class="tab-content" *ngIf="activeTab === 'analytics'">
                <h3>{{ currentLanguage === 'EN' ? 'Analytics' : 'Analytik' }}</h3>
                <div class="cookie-toggle-row">
                    <span class="toggle-label">{{ currentLanguage === 'EN' ? 'Enable Analytics' : 'Analytik aktivieren' }}</span>
                    <label class="toggle-switch">
                        <input type="checkbox" [(ngModel)]="analyticalCookies">
                        <span class="toggle-slider"></span>
                    </label>
                </div>

                <div class="cookie-service-section">
                    <h4>Google Analytics 4</h4>
                    <div class="content-text" *ngIf="currentLanguage === 'EN'">
                        <p><strong>The provider/processor</strong><br>is Google Ireland Limited (Gordon House, Barrow Street, Dublin 4, Ireland). Processing may also be carried out by affiliated companies of Google LLC (USA).</p>
                        <p><strong>Purpose(s)</strong><br>Audience measurement, analysis of the use of our website, creation of aggregated reports to improve content, performance and user guidance.</p>
                        <p><strong>Technologies such</strong><br>as cookies (especially first-party cookies like _ga and _ga_&lt;container-id&gt;) and possibly comparable identifiers for session/user recognition.</p>
                        <p><strong>Storage duration</strong></p>
                        <ul class="cookie-duration-list">
                            <li><span class="cookie-name">_ga</span> : 400 days</li>
                            <li><span class="cookie-name">_ga_&lt;container-id&gt;</span> : 400 days</li>
                        </ul>
                        <p class="cookie-note">Note: Browsers may technically limit the actual storage duration (e.g., shortened by browser policies).</p>
                    </div>
                    <div class="content-text" *ngIf="currentLanguage === 'DE'">
                        <p><strong>Der Anbieter/Verarbeiter</strong><br>ist Google Ireland Limited (Gordon House, Barrow Street, Dublin 4, Irland). Die Verarbeitung kann auch durch verbundene Unternehmen von Google LLC (USA) erfolgen.</p>
                        <p><strong>Zweck(e)</strong><br>Zielgruppenmessung, Analyse der Nutzung unserer Website, Erstellung aggregierter Berichte zur Verbesserung von Inhalten, Leistung und Benutzerführung.</p>
                        <p><strong>Technologien wie</strong><br>Cookies (insbesondere First-Party-Cookies wie _ga und _ga_&lt;container-id&gt;) und möglicherweise vergleichbare Identifikatoren für die Sitzungs-/Benutzererkennung.</p>
                        <p><strong>Speicherdauer</strong></p>
                        <ul class="cookie-duration-list">
                            <li><span class="cookie-name">_ga</span> : 400 Tage</li>
                            <li><span class="cookie-name">_ga_&lt;container-id&gt;</span> : 400 Tage</li>
                        </ul>
                        <p class="cookie-note">Hinweis: Browser können die tatsächliche Speicherdauer technisch begrenzen (z.B. durch Browser-Richtlinien verkürzt).</p>
                    </div>
                </div>

                <div class="cookie-service-section">
                    <h4>Microsoft Clarity</h4>
                    <div class="content-text" *ngIf="currentLanguage === 'EN'">
                        <p><strong>The provider/processor</strong><br>is Microsoft Corporation (One Microsoft Way, Redmond, WA 98052, USA).</p>
                        <p><strong>Purpose(s)</strong><br>Session recordings, heatmaps, and behavioral analytics to understand user interactions and improve website usability.</p>
                        <p><strong>Technologies such</strong><br>as cookies and scripts for tracking user behavior on the website.</p>
                        <p><strong>Storage duration</strong></p>
                        <ul class="cookie-duration-list">
                            <li><span class="cookie-name">_clck</span> : 1 year</li>
                            <li><span class="cookie-name">_clsk</span> : 1 day</li>
                            <li><span class="cookie-name">CLID</span> : 1 year</li>
                            <li><span class="cookie-name">MUID</span> : 1 year</li>
                        </ul>
                    </div>
                    <div class="content-text" *ngIf="currentLanguage === 'DE'">
                        <p><strong>Der Anbieter/Verarbeiter</strong><br>ist Microsoft Corporation (One Microsoft Way, Redmond, WA 98052, USA).</p>
                        <p><strong>Zweck(e)</strong><br>Sitzungsaufzeichnungen, Heatmaps und Verhaltensanalysen, um Benutzerinteraktionen zu verstehen und die Benutzerfreundlichkeit der Website zu verbessern.</p>
                        <p><strong>Technologien wie</strong><br>Cookies und Skripte zur Verfolgung des Benutzerverhaltens auf der Website.</p>
                        <p><strong>Speicherdauer</strong></p>
                        <ul class="cookie-duration-list">
                            <li><span class="cookie-name">_clck</span> : 1 Jahr</li>
                            <li><span class="cookie-name">_clsk</span> : 1 Tag</li>
                            <li><span class="cookie-name">CLID</span> : 1 Jahr</li>
                            <li><span class="cookie-name">MUID</span> : 1 Jahr</li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Marketing Tab -->
            <div class="tab-content" *ngIf="activeTab === 'marketing'">
                <h3>{{ currentLanguage === 'EN' ? 'Advertising/Marketing' : 'Werbung/Marketing' }}</h3>
                <div class="cookie-toggle-row">
                    <span class="toggle-label">{{ currentLanguage === 'EN' ? 'Enable Marketing' : 'Marketing aktivieren' }}</span>
                    <label class="toggle-switch">
                        <input type="checkbox" [(ngModel)]="marketingCookies">
                        <span class="toggle-slider"></span>
                    </label>
                </div>

                <div class="cookie-service-section">
                    <h4>Google AdSense</h4>
                    <div class="content-text" *ngIf="currentLanguage === 'EN'">
                        <p><strong>The provider/processor</strong><br>is Google Ireland Limited (Gordon House, Barrow Street, Dublin 4, Ireland). Processing may also be carried out by affiliated companies of Google LLC (USA).</p>
                        <p><strong>Purpose(s)</strong><br>Display of personalized advertisements based on your interests and browsing behavior. Conversion tracking and remarketing.</p>
                        <p><strong>Technologies such</strong><br>as cookies (including _gcl_au for conversion linker, FCCDCF, FCNEC) and comparable identifiers for ad personalization and measurement.</p>
                        <p><strong>Storage duration</strong></p>
                        <ul class="cookie-duration-list">
                            <li><span class="cookie-name">_gcl_au</span> : 90 days</li>
                            <li><span class="cookie-name">FCCDCF</span> : 1 year</li>
                            <li><span class="cookie-name">FCNEC</span> : 1 year</li>
                        </ul>
                        <p class="cookie-note">Note: Browsers may technically limit the actual storage duration (e.g., shortened by browser policies).</p>
                    </div>
                    <div class="content-text" *ngIf="currentLanguage === 'DE'">
                        <p><strong>Der Anbieter/Verarbeiter</strong><br>ist Google Ireland Limited (Gordon House, Barrow Street, Dublin 4, Irland). Die Verarbeitung kann auch durch verbundene Unternehmen von Google LLC (USA) erfolgen.</p>
                        <p><strong>Zweck(e)</strong><br>Anzeige personalisierter Werbung basierend auf Ihren Interessen und Ihrem Surfverhalten. Conversion-Tracking und Remarketing.</p>
                        <p><strong>Technologien wie</strong><br>Cookies (einschließlich _gcl_au für den Conversion-Linker, FCCDCF, FCNEC) und vergleichbare Identifikatoren für Anzeigenpersonalisierung und -messung.</p>
                        <p><strong>Speicherdauer</strong></p>
                        <ul class="cookie-duration-list">
                            <li><span class="cookie-name">_gcl_au</span> : 90 Tage</li>
                            <li><span class="cookie-name">FCCDCF</span> : 1 Jahr</li>
                            <li><span class="cookie-name">FCNEC</span> : 1 Jahr</li>
                        </ul>
                        <p class="cookie-note">Hinweis: Browser können die tatsächliche Speicherdauer technisch begrenzen (z.B. durch Browser-Richtlinien verkürzt).</p>
                    </div>
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="customize-buttons">
                <button class="btn tr-btn-primary btn-accept" (click)="saveCustomPreferences()">
                    {{ currentLanguage === 'EN' ? 'Save Preferences' : 'Einstellungen speichern' }}
                </button>
                <button class="btn tr-btn-secondary btn-back" (click)="showCustomize = false">
                    {{ currentLanguage === 'EN' ? 'Back' : 'Zurück' }}
                </button>
            </div>
        </div>
    </div>
</div>
<div class="backdrop" *ngIf="!cookieAccepted"></div>
